"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _require = require("../../utils"),
    mixin = _require.mixin;

var EventModifierMixinImpl = require("./EventModifierMixin-impl").implementation;

var UIEventImpl = require("./UIEvent-impl").implementation;

var KeyboardEventInit = require("../generated/KeyboardEventInit");

var KeyboardEventImpl = /*#__PURE__*/function (_UIEventImpl) {
  _inherits(KeyboardEventImpl, _UIEventImpl);

  var _super = _createSuper(KeyboardEventImpl);

  function KeyboardEventImpl() {
    _classCallCheck(this, KeyboardEventImpl);

    return _super.apply(this, arguments);
  }

  _createClass(KeyboardEventImpl, [{
    key: "initKeyboardEvent",
    value: function initKeyboardEvent(type, bubbles, cancelable, view, key, location, ctrlKey, altKey, shiftKey, metaKey) {
      if (this._dispatchFlag) {
        return;
      }

      this.initUIEvent(type, bubbles, cancelable, view, 0);
      this.key = key;
      this.location = location;
      this.ctrlKey = ctrlKey;
      this.altKey = altKey;
      this.shiftKey = shiftKey;
      this.metaKey = metaKey;
    }
  }]);

  return KeyboardEventImpl;
}(UIEventImpl);

mixin(KeyboardEventImpl.prototype, EventModifierMixinImpl.prototype);
KeyboardEventImpl.defaultInit = KeyboardEventInit.convert(undefined);
module.exports = {
  implementation: KeyboardEventImpl
};